export function isEmptyFilterValue(value: unknown): boolean {
  return value == null || (Array.isArray(value) && value.length === 0);
}

export function compactFilterRecord<T extends object>(filters: T): Partial<T> {
  const next: Partial<T> = {};

  for (const key of Object.keys(filters) as Array<keyof T>) {
    const value = filters[key];

    if (!isEmptyFilterValue(value)) {
      next[key] = value;
    }
  }

  return next;
}
